import { useEffect, useState } from 'react';
import { REVIEWS, GOOGLE_REVIEWS_URL } from './data.js';
import { getGoogleAggregate } from './google-reviews.js';

// Rating + socials bar — gebruikt op Spoedservice, Werkgebied, Blog, etc.
//
// SEO-friendly: prerendered HTML toont de fallback-cijfers uit data.js
// (zodat Google bij eerste crawl harde cijfers ziet). Client-side
// upgraden we naar het LIVE totaal via getGoogleAggregate(), zodat het
// aantal reviews vanzelf meegroeit zonder rebuild.
//
// Het rating-blok is daarnaast clickable — bezoekers landen direct in
// het Google Business-profiel waar ze alle reviews kunnen lezen of zelf
// een review kunnen achterlaten.
export function RatingBar() {
  const [agg, setAgg] = useState({ rating: REVIEWS.rating, total: REVIEWS.total });

  useEffect(() => {
    let alive = true;
    getGoogleAggregate().then(data => {
      if (!alive || !data) return;
      // Alleen updaten bij verschil (anders re-renders zonder reden)
      if (data.rating !== agg.rating || data.total !== agg.total) {
        setAgg({ rating: data.rating, total: data.total });
      }
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // NL-notatie voor de rating: punt → komma (4.6 → 4,6)
  const ratingStr = String(agg.rating).replace('.', ',');
  const label = `${agg.total} Google reviews`;
  const ariaLabel = `${ratingStr} sterren op ${agg.total} Google reviews, bekijk op Google`;

  return (
    <div className="rdam-rating-bar" aria-label={ariaLabel}>
      <a
        href={GOOGLE_REVIEWS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="rrb-score rrb-score-link"
        aria-label={ariaLabel}
        title="Bekijk al onze Google reviews"
      >
        {/* Google G-icoon ter visuele verankering. SVG ipv emoji voor
            consistente kleuren over alle platforms. */}
        <span className="rrb-google" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
        </span>
        <span className="rrb-num">{ratingStr}</span>
        <span className="rrb-meta">
          <span className="rrb-stars" aria-hidden="true">★★★★★</span>
          <span className="rrb-label">{label}</span>
        </span>
        <span className="rrb-cta" aria-hidden="true">Bekijk reviews →</span>
      </a>
      {/* Social-icons verwijderd 2026-05-26: ABC heeft (nog) geen actieve
          IG/FB/TikTok accounts. Bij heractivering: zie git-history voor markup. */}
    </div>
  );
}
